import React, { useState, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const Lightbox = ({ images, selected, onSelect, onClose, testId = 'lightbox' }) => {
  const [startX, setStartX] = useState(null);
  const [swiped, setSwiped] = useState(false);

  const index = selected ? images.findIndex((img) => img.id === selected.id) : -1;
  const count = images.length;

  const showPrev = () => index >= 0 && onSelect(images[(index - 1 + count) % count]);
  const showNext = () => index >= 0 && onSelect(images[(index + 1) % count]);

  const handlePointerDown = (e) => { setStartX(e.clientX); setSwiped(false); };
  const handlePointerUp = (e) => {
    if (startX === null) return;
    const delta = e.clientX - startX;
    if (delta > 50) { showPrev(); setSwiped(true); }
    else if (delta < -50) { showNext(); setSwiped(true); }
    setStartX(null);
  };
  const handleBackdropClick = () => {
    if (swiped) { setSwiped(false); return; }
    onClose();
  };

  useEffect(() => {
    if (!selected) return;
    const onKey = (e) => {
      if (e.key === 'ArrowLeft') showPrev();
      else if (e.key === 'ArrowRight') showNext();
      else if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });

  if (!selected) return null;

  return (
    <div
      data-testid={testId}
      className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 select-none touch-pan-y"
      onClick={handleBackdropClick}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
    >
      <button
        data-testid="lightbox-close-btn"
        className="absolute top-8 right-8 text-white hover:text-gray-300 transition-colors z-10"
        onClick={onClose}
        aria-label="Close"
      >
        <X size={32} />
      </button>
      {count > 1 && (
        <>
          <button
            data-testid="lightbox-prev-btn"
            className="absolute left-2 md:left-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors p-2 z-10"
            onClick={(e) => { e.stopPropagation(); showPrev(); }}
            aria-label="Previous image"
          >
            <ChevronLeft size={40} />
          </button>
          <button
            data-testid="lightbox-next-btn"
            className="absolute right-2 md:right-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors p-2 z-10"
            onClick={(e) => { e.stopPropagation(); showNext(); }}
            aria-label="Next image"
          >
            <ChevronRight size={40} />
          </button>
        </>
      )}
      <div className="max-w-5xl max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
        <img
          key={selected.id}
          data-testid="lightbox-image"
          src={selected.url}
          alt={selected.alt}
          className="w-full h-full object-contain animate-fade-in"
          draggable={false}
        />
      </div>
      <p
        data-testid="lightbox-counter"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-xs tracking-widest"
      >
        {index + 1} / {count}
      </p>
    </div>
  );
};
